import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import queryClient from '@app/queryClient';
import { bankApplicationsApi } from '@modules/opportunities/entities/bankApplication/api';
import { t } from 'i18next';
import { SetOpportunityBankRatesDTO } from '../api/dto/setOpportunityBankRates.dto';

const useSetOpportunityBankRates = (opportunityId: string, callbackFn?: () => void) => {
  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['useSetOpportunityBankRates'],
    mutationFn: (data: { opportunityId: string; body: SetOpportunityBankRatesDTO }) =>
      bankApplicationsApi.setOpportunityBankRates(opportunityId, data.body),
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: ['clientOpportunity', opportunityId] });
      await queryClient.refetchQueries({ queryKey: ['bankDigitalDocs', opportunityId] });
      if (callbackFn) {
        callbackFn();
      }
      toast('info', { message: t('opportunity.caseSubmission.bankSelection.notifications.banksSelected') });
    },
    onError: () => {
      toast('error', { message: t('opportunity.caseSubmission.bankSelection.notifications.bankSelectionFailed') });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useSetOpportunityBankRates;
